module.exports = __webpack_public_path__ + "img/diente18.06f5eaaf.png";